module.exports = __webpack_public_path__ + "img/undraw_Group_chat_re_frmo.36b5decf.svg";